import React from 'react'
import './graph.css'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts'
import moment from 'moment'
import {useState,useEffect} from 'react'


const getOption = (waterLvlData, unit) => {

  return {
    chart: {
      type: 'line',
      style: {
        height: '60vh'
      }
    },
    title: {
      text: ''
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: {
      title: {
        text: unit
      }
    }, legend: {
      enabled: false
    },
    series: [{
      name: 'Nagmati',
      data: waterLvlData,
    }]
  }
}

function Graph({ data }) {
  const [dateTime, setDateTime] = useState(null);

  const graphImg = data[0]?.images[0]?.name
  const waterLvlData = [];
  const unit = data[0]?.observations[0]?.unit
  data[0]?.observations[0]?.data?.map((item, i) => {
    var dateToNPT = moment(new Date(item.datetime)).format('YYYY-MM-DDTHH:mm:ss+00:00')
    var value = item.value;
    waterLvlData.push([Date.parse(dateToNPT), value])
  })
  function dateTimeInterval(){
    const date = moment(new Date()).format("dddd, MMM Do YYYY, h:mm a");
    return date;
  }
  useEffect(() => {
    setInterval(()=>{
      setDateTime(dateTimeInterval())
    }, 1000);
  }, dateTime);

  // console.log(setInterval(dateTime, 1000))
  return (
    <div className="graph-container">
      <div className="header-heading">
        Automatic Hydrological Station
      </div>
      <div className="graph-header">
        <div className='city-name'>
          Nagmati at Sundarijal
        </div>
        <div className='date-time'>
          Date: {dateTime}
        </div>
      </div>

      <div className="graph-content">
        <div className="graph-data-left">
          <div className='graph'>
            <div className="graph-content-header">
              <div>Water Level</div>
            </div>
            <div className="water-level-graph">
              <HighchartsReact
                highcharts={Highcharts}
                options={getOption(waterLvlData, unit)}
              />

            </div>
            <div className="graph-table">
              <table>
                <tr>
                  <th>Particular</th>
                  <th>Real Time</th>
                </tr>
                <tr>
                  <td>Automatic Water Level</td>
                  <td>{waterLvlData.length ? (waterLvlData[waterLvlData.length - 1][1]).toFixed(2) : 0}</td>
                </tr>
              </table>
            </div>
          </div>

        </div>
        <div className='graph-img' style={{
          backgroundImage: `url("https://daq.wscada.net/images/${graphImg}")`,
          width: "100%",
          height: "73vh",
          backgroundRepeat: 'no-repeat',
          backgroundSize:"cover"
        }}>
        </div>
      </div>
    </div>
  )
}

export default Graph